export function useResponsiveScreenFacade () {
  const screenWidthResolution = ref()

  const isXs = computed((): boolean => screenWidthResolution.value < 640) as ComputedRef<boolean>
  const isSm = computed((): boolean => screenWidthResolution.value >= 640) as ComputedRef<boolean>
  const isMd = computed((): boolean => screenWidthResolution.value >= 768) as ComputedRef<boolean>
  const isLg = computed((): boolean => screenWidthResolution.value >= 1024) as ComputedRef<boolean>
  const isXl = computed((): boolean => screenWidthResolution.value >= 1280) as ComputedRef<boolean>
  const is2Xl = computed((): boolean => screenWidthResolution.value >= 1536) as ComputedRef<boolean>

  function onResize (): void {
    screenWidthResolution.value = window.innerWidth
  }

  onMounted(() => {
    screenWidthResolution.value = window?.innerWidth
    window.addEventListener('resize', onResize)
  })

  onUnmounted(() => {
    window.removeEventListener('resize', onResize)
  })

  return { isXs, isSm, isMd, isLg, isXl, is2Xl }
}
